// extracted by mini-css-extract-plugin
module.exports = {"chat":"styles_chat__fi9Ty","inputDescription":"styles_inputDescription__2sTxy"};